import React, { useEffect, useState } from 'react'
import { Link } from 'gatsby'
import { Notification } from 'module-tsl-ui-notification'
import LinkableTitle from '../components/linkableTitle'
import 'focus-visible'

const FRONTEND_WEEK_DAY = 4

const getNextFrontendDay = (date) => {
  const month = date.getMonth() + 1
  const year = date.getFullYear()
  let lastThursday = new Date(year, month, 0)
  if (lastThursday.getDay() < FRONTEND_WEEK_DAY) {
    lastThursday = lastThursday.setDate(lastThursday.getDate() - 7)
  }
  lastThursday = new Date(lastThursday)
  lastThursday.setDate(lastThursday.getDate() - (lastThursday.getDay() - FRONTEND_WEEK_DAY))
  return lastThursday.toLocaleDateString('en-us', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
}

const IndexPage = () => {
  const [nextFrontendDate, setNextFrontendDate] = useState('');
  useEffect(() => {
    setNextFrontendDate((getNextFrontendDay(new Date())))
  }, []);
  return (
    <React.Fragment>
      <div className="page-welcome-header">
        <h2>WELCOME TO THE</h2>
        <h1>Tes Styleguide</h1>
      </div>
      <div className="page-content page-content--homepage">
        <blockquote>
          Consistency, re-use, and meaningful user experiences.
        </blockquote>
        <p>Our styleguide is a shared toolbox of design and engineering solutions, allowing us to build faster and smarter, and deliver a consistent UI that keeps users orientated.</p>
        <p>Here you'll find an evergreen guide to our UI elements, including design principles and technical how-tos.</p>
<div className="page-content__callout">
        <h3>Team collaboration</h3>
        <p>Our frontend is nothing without your involvement. Frontend Day is a day set aside for some cross-team effort to maintain/enhance our shared frontend resources. It's a great way of learning some new frontend skills.</p>
        <strong>Next Frontend Day will be {nextFrontendDate}</strong>
        <p>Head over to our <a href="https://app.zenhub.com/workspaces/frontend-5a968c9b1bb5fa278e6c7d8f/board?repos=90969861">board in Zenhub</a> to see what we're working on, and get involved by joining the <a href="slack://channel?team=T0C6075FX&id=CEHS72V8X">Frontend Slack Channel.</a> </p>
</div>
  <LinkableTitle name="sections" title="Styleguide sections"/>
        <div className="container page-boxes">
          <div className="row">
            <div className="col-xs-12 col-md-6">
              <Link
                to="/guidelines"
                className="page-box page-box--with-icon page-box--guidelines"
              >
                Guidelines<span className="wip-label">WIP</span>
              </Link>
            </div>
            <div className="col-xs-12 col-md-6">
              <Link
                to="/core"
                className="page-box page-box--with-icon page-box--styles"
              >
                Core
              </Link>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-md-6">
              <Link
                to="/elements"
                className="page-box page-box--with-icon page-box--elements"
              >
                Elements
              </Link>
            </div>
            <div className="col-xs-12 col-md-6">
              <Link
                to="/components"
                className="page-box page-box--with-icon page-box--components"
              >
                Components
              </Link>
            </div>
          </div>
        </div>
        <hr/>
        <LinkableTitle name="repositories" title="Internal repositories"/>
        <Notification defaultShow type="warning" isInline>
          Some links on this styleguide won't be publicly accessible as they will
          point to either private repositories or private internal documentation.
        </Notification>
        <br/>
        <a
          href="https://github.com/tes/app-styleguide"
          className="page-box page-box--with-icon page-box--github"
        >
          Styleguide
        </a>
        <a
          href="https://github.com/tes/module-tsl-ui"
          className="page-box page-box--with-icon page-box--github"
        >
          UI Components (module-tsl-ui)
        </a>
        <a
          href="https://github.com/tes/tes-sass"
          className="page-box page-box--with-icon page-box--github"
        >
          Sass variables/mixins
        </a>
      </div>
    </React.Fragment>
);
}

export default IndexPage
